interface NumericControlProps {
  readonly id: string;
  readonly label: string;
  readonly max: number;
  readonly min: number;
  readonly onChange: (value: number) => void;
  readonly step: number;
  readonly suffix?: string;
  readonly value: number;
}

export function NumericControl({
  id,
  label,
  max,
  min,
  onChange,
  step,
  suffix,
  value,
}: NumericControlProps) {
  const update = (rawValue: string) => {
    const numericValue = Number(rawValue);
    if (Number.isFinite(numericValue)) onChange(numericValue);
  };

  return (
    <div className="style-control numeric-control">
      <label htmlFor={`${id}-range`}>{label}</label>
      <div className="numeric-control-inputs">
        <input
          id={`${id}-range`}
          max={max}
          min={min}
          onChange={(event) => update(event.target.value)}
          step={step}
          type="range"
          value={value}
        />
        <span className="numeric-value-input">
          <input
            aria-label={`${label} value`}
            max={max}
            min={min}
            onChange={(event) => update(event.target.value)}
            step={step}
            type="number"
            value={value}
          />
          {suffix ? <small>{suffix}</small> : null}
        </span>
      </div>
    </div>
  );
}
